import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import Particle from "./Particle";

function Instagram() {
  return (
    <>
      <Helmet>
        <title>Photography | Vedant Gaidhane</title>
        <meta
          name="description"
          content="Photography hobby of Vedant Gaidhane — creative shots and visual stories."
        />
      </Helmet>

      <div
        style={{
          minHeight: "100vh",
          background: "var(--bg-primary)",
          paddingTop: "100px",
          paddingBottom: "60px",
          position: "relative",
        }}
      >
        <Particle />
        <Container style={{ position: "relative", zIndex: 2 }}>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              {/* Badge */}
              <div
                style={{
                  display: "inline-flex", alignItems: "center", gap: 8,
                  background: "rgba(168,85,247,0.10)",
                  border: "1px solid rgba(168,85,247,0.22)",
                  borderRadius: "100px", padding: "5px 14px",
                  fontSize: "0.82rem", color: "#a855f7",
                  fontWeight: 500, marginBottom: "1.4rem",
                }}
              >
                📸 Beyond the Terminal
              </div>

              <h1
                style={{
                  fontWeight: 800, fontSize: "3rem", color: "#fff",
                  letterSpacing: "-1px", marginBottom: "0.75rem",
                }}
              >
                Photography
              </h1>
              <p
                style={{
                  fontSize: "1.05rem", color: "var(--muted)",
                  maxWidth: 560, margin: "0 auto 2rem", lineHeight: 1.75,
                }}
              >
                DevOps by day, photographer by heart. Capturing light, landscapes, and
                quiet moments — one click at a time.
              </p>

              <a
                href="https://www.instagram.com/clickss_by_v/profilecard/?igsh=bmxmOXpxZTVrcjZr"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex", alignItems: "center", gap: 8,
                  background: "linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)",
                  color: "#fff", borderRadius: "12px",
                  padding: "0.75rem 1.8rem",
                  fontWeight: 600, fontSize: "0.95rem",
                  textDecoration: "none",
                  boxShadow: "0 4px 20px rgba(253,29,29,0.28)",
                  transition: "transform 0.22s, box-shadow 0.22s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 10px 32px rgba(253,29,29,0.42)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(253,29,29,0.28)";
                }}
              >
                📷 View Instagram Gallery
              </a>
            </Col>
          </Row>

          {/* Photo showcase */}
          <Row className="justify-content-center" style={{ marginTop: "3rem" }}>
            <Col md={9} xs={12}>
              <div
                style={{
                  borderRadius: "20px", overflow: "hidden",
                  border: "1px solid rgba(255,255,255,0.07)",
                  boxShadow: "0 24px 80px rgba(0,0,0,0.55)",
                }}
              >
                <img
                  src={require("../Assets/Landscape.jpg")}
                  alt="Photography Showcase by Vedant Gaidhane"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Instagram;
